import * as React from 'react';

import type { SocialProofStatisticType } from 'bundles/career-plans/components/data/types/career-plans';
import CareerPlansToggletip from 'bundles/career-plans/components/header/CareerPlansToggletip';

import _t from 'i18n!nls/career-plans';

import 'css!./__styles__/CareerPlansSocialProof';

type Props = {
  socialProofStatistics?: Array<SocialProofStatisticType>;
  socialProofStatisticsSource?: string;
  socialProofStatisticsSourceDescription?: string;
};

const CareerPlansSocialProof = ({
  socialProofStatistics,
  socialProofStatisticsSource = '',
  socialProofStatisticsSourceDescription = '',
}: Props) => {
  if (!socialProofStatistics || !socialProofStatistics?.length) return null;
  const renderSocialProofStatistic = ({ description, value, unit = '' }: SocialProofStatisticType) => (
    <div
      key={`socialProofStat-${value}${unit}`}
      className="careerPlansSocialProof-item"
      data-e2e="CareerPlansSocialProof-item"
    >
      <div className="careerPlansSocialProof-item--stat">{`${value}${unit}`}</div>
      <span className="careerPlansSocialProof-item--description">{description}</span>
    </div>
  );

  return (
    <aside className="rc-CareerPlansSocialProof" data-e2e="CareerPlansSocialProof">
      <h2 className="careerPlansSocialProof-description careerPlans-sectionHeader">
        {_t('What learners who have completed these courses say')}
      </h2>
      <div className="careerPlansSocialProof-items">{socialProofStatistics.map(renderSocialProofStatistic)}</div>
      <div className="careerPlansSocialProof-toolTip">
        {!!socialProofStatisticsSourceDescription.length && !!socialProofStatisticsSource.length && (
          <CareerPlansToggletip
            socialProofStatisticsSource={socialProofStatisticsSource}
            socialProofStatisticsSourceDescription={socialProofStatisticsSourceDescription}
          />
        )}
        {!socialProofStatisticsSourceDescription.length && !!socialProofStatisticsSource.length && (
          <span className="careerPlansSocialProof-toolTip--text">{socialProofStatisticsSource}</span>
        )}
      </div>
    </aside>
  );
};
export default CareerPlansSocialProof;
